import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Container, Box, Typography, Button, Grid, Paper } from '@mui/material';
import { MedicalServices as MedicalServicesIcon } from '@mui/icons-material';

const Home = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)',
      }}
    >
      {/* Header */}
      <Box component="header" sx={{ py: 4, bgcolor: 'white', boxShadow: 1 }}>
        <Container maxWidth="lg">
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <MedicalServicesIcon color="primary" sx={{ fontSize: 40 }} />
              <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold' }}>
                HMS Pro
              </Typography>
            </Box>
            <Button 
              component={RouterLink} 
              to="/login" 
              variant="contained" 
              color="primary"
              size="large"
            >
              Login
            </Button>
          </Box>
        </Container>
      </Box>

      {/* Hero Section */}
      <Box component="main" sx={{ flex: 1, py: 10 }}>
        <Container maxWidth="lg">
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography variant="h2" component="h2" sx={{ mb: 3, fontWeight: 'bold' }}>
                Modern Healthcare Management System
              </Typography>
              <Typography variant="h5" color="text.secondary" sx={{ mb: 4 }}>
                Streamline your hospital operations with our comprehensive healthcare management solution.
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, mt: 4 }}>
                <Button 
                  component={RouterLink} 
                  to="/login" 
                  variant="contained" 
                  color="primary" 
                  size="large"
                >
                  Get Started
                </Button>
                <Button 
                  component="a" 
                  href="#features" 
                  variant="outlined" 
                  size="large"
                >
                  Learn More
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper 
                elevation={3} 
                sx={{ 
                  p: 3, 
                  height: '100%',
                  minHeight: 300,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'linear-gradient(45deg, #e3f2fd 30%, #bbdefb 90%)',
                }}
              >
                <Typography variant="h6" color="text.secondary">
                  Hospital Management System Dashboard Preview
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Features Section */}
      <Box id="features" sx={{ py: 10, bgcolor: 'background.paper' }}>
        <Container maxWidth="lg">
          <Typography variant="h3" align="center" sx={{ mb: 6, fontWeight: 'bold' }}>
            Features
          </Typography>
          <Grid container spacing={4}>
            {[
              {
                title: 'Appointment Management',
                description: 'Easily schedule and manage patient appointments with our intuitive interface.'
              },
              {
                title: 'Patient Records',
                description: 'Access and update patient records securely from anywhere, anytime.'
              },
              {
                title: 'Billing & Invoicing',
                description: 'Streamline your billing process with automated invoicing and payment tracking.'
              },
            ].map((feature, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Paper sx={{ p: 3, height: '100%' }}>
                  <Typography variant="h5" component="h3" sx={{ mb: 2, fontWeight: 'medium' }}>
                    {feature.title}
                  </Typography>
                  <Typography color="text.secondary">
                    {feature.description}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Footer */}
      <Box component="footer" sx={{ py: 4, bgcolor: 'background.paper', borderTop: '1px solid', borderColor: 'divider' }}>
        <Container maxWidth="lg">
          <Typography variant="body2" color="text.secondary" align="center">
            © {new Date().getFullYear()} HMS Pro. All rights reserved.
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default Home;
